import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FlowConstants, TranslationUtils } from '../utils';
import { FlexiExpressionData } from '@customer-apps/flexi-logic';
import { ContextModelService } from '../services';

@Pipe({
    name: 'translationKey',
    pure: false
})
export class TranslationKeyPipe implements PipeTransform {
    private translate = inject(TranslateService);
    private contextModel = inject(ContextModelService);

    transform(
        translationKey: string | undefined,
        translationData?: FlexiExpressionData,
        value?: string | number | boolean
    ): string | undefined {
        if (!translationKey) {
            return undefined;
        }

        if (typeof value === 'string' || typeof value === 'number') {
            translationKey = translationKey.replace(FlowConstants.VALUE_PLACEHOLDER, `${value}`);
        }
        // TODO: Handle boolean value (example is needed)

        if (!translationData) {
            return this.translate.instant(translationKey);
        }

        const params = TranslationUtils.sanitizeTranslationParams(this.contextModel.processJsonLogic(translationData));

        return this.translate.instant(translationKey, params);
    }
}
